import { locationCodeValidation } from "utils/validations";

export const OBEETEE_SELLER_ID = 2;

export const normalizeScannedLocationCode = (value) => {
  const trimmedValue = value.trim();
  return locationCodeValidation(trimmedValue) || trimmedValue;
};

export const findAssignedLocation = (matches, locationCode) =>
  matches.find((item) => item.detail.location_code === locationCode);

export const findInventoryLocation = (inventories, locationCode) => {
  const inventory = inventories.find(
    (item) => item.location.code === locationCode && Number(item.qty) > 0,
  );
  return inventory ? inventory.location : null;
};

export const isCurrentLocationRequest = ({
  session,
  currentSession,
  resolved,
}) => session === currentSession && !resolved;

export const isCurrentAlternativeRequest = ({
  session,
  currentSession,
  requestVersion,
  currentRequestVersion,
  resolved,
}) =>
  isCurrentLocationRequest({ session, currentSession, resolved }) &&
  requestVersion === currentRequestVersion;
